import * as R from 'ramda'
import React from 'react'
import { Form } from 'semantic-ui-react'
import { getAccountDetail, patchAccountDetail } from '../api/sync/index'
import avatarFemale from '../assets/avatar_female.png'
import avatarMale from '../assets/avatar_male.png'
import AccountAndMailingForm from '../components/AccountAndMailingForm/index'
import { Loader } from '../components/Loader'
import { getBase64 } from '../utils/index'

class Account extends React.Component {
  state = {
    loading: false
  }

  componentDidMount = () => {
    getAccountDetail().then(res => {
      this.setState({ ...R.filter(R.identity, res.data) })
      this.updateBirthDayField()
    })
    document.title = 'Run24Hrs - แก้ไขข้อมูลส่วนตัว'
  }

  updateBirthDayField = () => {
    this.setState({ day: this.state.birth_day.split('-')[2] })
    this.setState({ month: this.state.birth_day.split('-')[1] })
    this.setState({ year: this.state.birth_day.split('-')[0] })
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })
  }

  updateBirthDay = () =>
    this.setState({
      birth_day: `${this.state.year}-${this.state.month}-${this.state.day}`
    })

  handleSubmit = async () => {
    this.setState({ loading: true })

    this.setState(
      {
        birth_day: `${this.state.year}-${this.state.month}-${this.state.day}`
      },
      () => {
        const {
          birth_day,
          firstname,
          lastname,
          gender,
          name,
          phone_number,
          address_1,
          sub_district,
          district,
          province,
          country,
          postal_code
        } = this.state
        patchAccountDetail({
          birth_day,
          firstname,
          lastname,
          gender,
          name,
          phone_number,
          address_1,
          sub_district,
          district,
          province,
          country,
          postal_code,
          image: this.state.image ? this.state.image : null
        }).then(() => {
          this.props.history.push(`/me`)
        })
      }
    )
  }
  handleFile = e => {
    getBase64(e.target.files[0]).then(data => {
      this.setState({ profile_picture: data })
      this.setState({ image: data })
    })
  }

  getAvatar = () => {
    const gender = R.path(['gender'], this.state)
    let avatar = avatarMale
    if (gender === 'female') avatar = avatarFemale
    return R.pathOr(avatar, ['profile_picture'], this.state)
  }

  render() {
    return (
      <React.Fragment>
        {this.state.loading ? (
          <Loader />
        ) : (
          <React.Fragment>
            {this.state.profile_picture && (
              <img
                style={{ margin: '0 auto' }}
                className="ui small image circular"
                src={this.getAvatar()}
              />
            )}
            <Form.Group className="mt10" style={{ textAlign: 'center' }}>
              <label className="ui button teal" htmlFor="image-upload">
                อัพโหลดรูปภาพประจำตัว
              </label>
              <Form.Input
                style={{ display: 'none' }}
                id="image-upload"
                name="image"
                type="file"
                onChange={this.handleFile}
              />
            </Form.Group>
            <AccountAndMailingForm
              handleChange={this.handleChange}
              birth_day={this.state.birth_day}
              firstname={this.state.firstname}
              lastname={this.state.lastname}
              email={this.state.email}
              gender={this.state.gender}
              name={this.state.name}
              phone_number={this.state.phone_number}
              address_1={this.state.address_1}
              sub_district={this.state.sub_district}
              district={this.state.district}
              province={this.state.province}
              country={this.state.country}
              postal_code={this.state.postal_code}
              onClickNext={this.handleSubmit}
              submitText="ตกลง"
              hideBackButton
            />
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

export default Account



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Account.js